import { memo, useContext, useEffect, useRef } from 'react';
import AnimateTop from 'components/AnimateTop';
import StepLayout from 'components/layout/StepLayout';
import Footer from 'components/footer/Footer';
import { FooterOkBtn, FooterPressText } from 'components/footer/Footer.styled';
import { Step7Content, Step7Option } from './Step7.styled';
import { useDispatch } from 'react-redux';
import { nextStep, prevStep } from 'store/slices/global.slice';
import BaseTitle from 'components/common/BaseTitle';
import { useSelector } from 'react-redux';
import { HiOutlineCheck } from 'react-icons/hi';
import Picker from 'components/date-picker/DatePicker';
import { UserFormContext } from 'components/UserForm';

const Step7 = () => {
  const dispatch = useDispatch();
  const { timezone } = useSelector((state) => state.form);
  const { dateData, setDateData, shortForm } = useContext(UserFormContext);
  const okRef = useRef(null);

  useEffect(() => {
    if (okRef.current) okRef.current.focus();
  }, [okRef]);

  return (
    <AnimateTop y={window.innerWidth < 768 ? '70px' : '100px'}>
      <StepLayout title="Now, let's see what time and date works for you.">
        <Step7Content>
          <BaseTitle type='subtitle' fw={500}>
            Please be aware these are NOT confirmed appoinments but only
            preferred options that we will try to accommodate.
          </BaseTitle>
          <BaseTitle type='subtitle' fw={500}>
            Appointment time is not confirmed until you speak to our operations
            team.
          </BaseTitle>
          <div>
            <span>Your Timezone</span> : <span>{timezone}</span>
          </div>
          <Step7Option>
            <span>Option 1</span>
            <div>
              <Picker
                setDateData={setDateData}
                value={dateData.date1}
                id='date1'
              />
            </div>
          </Step7Option>
          <Step7Option>
            <span>Option 2</span>
            <div>
              <Picker
                setDateData={setDateData}
                value={dateData.date2}
                id='date2'
              />
            </div>
          </Step7Option>
          <Step7Option>
            <span>Option 3</span>
            <div>
              <Picker
                setDateData={setDateData}
                value={dateData.date3}
                id='date3'
              />
            </div>
          </Step7Option>
        </Step7Content>
        <Footer
          nextArrowClick={() =>
            dispatch(nextStep({ step: !shortForm ? 8 : 6 }))
          }
          prevArrowClick={() => dispatch(prevStep({ step: 63 }))}
        >
          <FooterOkBtn
            onClick={() => dispatch(nextStep({ step: !shortForm ? 8 : 6 }))}
            ref={okRef}
          >
            OK <HiOutlineCheck />
          </FooterOkBtn>
          <FooterPressText>press Enter ↵</FooterPressText>
        </Footer>
      </StepLayout>
    </AnimateTop>
  );
};

export default memo(Step7);
